module.exports = require("./fa-AF.d.ts");